import React from 'react'
import NextImage from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Textarea } from '@wartek-id/textarea'

const CONFIRMATION_TEXT = 'SAYA SETUJU BAHWA DATA SUDAH BENAR DAN SESUAI'

type TDialogSendConfirmationProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}
export const DialogSendConfirmation: React.FC<TDialogSendConfirmationProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [confirmationInput, setConfirmationInput] = React.useState<string>('')
  const isConfirmed = React.useMemo(
    () => confirmationInput === CONFIRMATION_TEXT,
    [confirmationInput]
  )

  React.useEffect(() => {
    return () => {
      setConfirmationInput('')
    }
  }, [isOpen])

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      autoFocus={false}
      returnFocus={false}
      size="sm"
    >
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <NextImage
            src="/illustrations/img-document-penci-fill.png"
            alt="Document Icon"
            width={84}
            height={84}
          />
          <Text variant="display-sm">
            Ajukan Perencanaan ke Tim Kinerja dan Pejabat Penilai Kinerja?
          </Text>
          <Text variant="body-lg" color="subdued">
            Tim Kinerja dan Pejabat Penilai Kinerja akan lanjut memeriksa.
          </Text>
          <Text color="subdued">
            Mohon ketik kalimat persetujuan di bawah ini:
          </Text>
          <div className="p-1 rounded-md bg-surface-selected-default">
            <Text variant="heading-sm" className="!text-blue-60 select-none">
              {CONFIRMATION_TEXT}
            </Text>
          </div>

          <div className="w-8/12">
            <Textarea
              data-testid="dialog-send-confirm-textarea"
              placeholder="Ketik kalimat persetujuan di sini"
              value={confirmationInput}
              onChange={(e) => {
                setConfirmationInput((e?.target?.value ?? '').toUpperCase())
              }}
            />
          </div>

          <div className="flex pt-2 space-x-4">
            <Button
              data-testid="dialog-send-confirm-back"
              className="w-32"
              color="white"
              size="lg"
              onClick={onClose}
            >
              Kembali
            </Button>
            <Button
              data-testid="dialog-send-confirm-submit"
              className="w-32"
              disabled={!isConfirmed}
              color="blue"
              size="lg"
              onClick={onConfirm}
            >
              Kirim
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
